import { PricingTable } from "@clerk/clerk-react";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { useBillingStatus } from "../components/BillingStatusContext";
import { Header } from "../components/Header";

export const Route = createFileRoute("/pricing")({
  validateSearch: z.object({
    redirect_url: z.string().optional(),
  }),
  component: PricingPage,
});

function PricingPage() {
  const { redirect_url } = useSearch({ from: "/pricing" });
  // Guard against open-redirect: only allow relative paths
  const redirectUrl = redirect_url?.startsWith("/") ? redirect_url : "/";
  const { billingStatus } = useBillingStatus();
  // The configured limit is only known once the status request resolves.
  // Signed-out visitors (and a failed request) get non-numeric copy rather
  // than a hard-coded number that could drift from the server config.
  const iterationLimit = billingStatus?.iterations_limit;

  return (
    <div className="min-h-screen bg-[var(--bg-default)]">
      <Header currentPage="pricing" />

      <main className="px-6 pb-16 pt-8">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-10">
          <section className="rounded-[2rem] bg-[var(--bg-modal)] p-8 md:p-10">
            <div className="w-full">
              <p className="text-sm uppercase tracking-[0.3em] text-[var(--text-secondary)]">
                Membership
              </p>
              <h1 className="mt-4 text-4xl font-semibold text-[var(--text-primary)] md:text-5xl">
                Choose a plan and keep designing.
              </h1>
              <p className="mt-4 text-lg text-[var(--text-secondary)]">
                {iterationLimit != null
                  ? `The free plan includes ${iterationLimit} visualizations a month, resetting on the 1st. `
                  : "The free plan includes a monthly visualization allowance, resetting on the 1st. "}
                Subscribe for unlimited visualizations and high-resolution
                downloads. Your gallery stays available either way.
              </p>
            </div>
          </section>

          <section className="rounded-[2rem] bg-[var(--bg-modal)] p-4 md:p-6">
            <div className="clerk-pricing-theme dark flex flex-col gap-4 md:flex-row">
              <PricingTable
                newSubscriptionRedirectUrl={redirectUrl}
                fallback={
                  <div className="flex min-h-64 items-center justify-center text-[var(--text-secondary)]">
                    Loading plans...
                  </div>
                }
              />
              <PricingTable
                for="organization"
                newSubscriptionRedirectUrl="/organization#/organization-members"
                fallback={
                  <div className="flex min-h-64 items-center justify-center text-[var(--text-secondary)]">
                    Loading plans...
                  </div>
                }
              />
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
